import { useCustomMutation } from "@refinedev/core";
import { notification } from "antd";
import { SUBMIT_INVOICE_MUTATION } from "../queries";

interface SubmitInvoiceResponse {
  id: string;
  status: string;
  approvalType?: string;
  externalWorkflow?: Record<string, any>;
  submittedBy?: string;
}

interface UseSubmitInvoiceProps {
  onSuccess?: (data: SubmitInvoiceResponse) => void;
  onError?: (error: any) => void;
}

export const useSubmitInvoice = ({
  onSuccess,
  onError
}: UseSubmitInvoiceProps = {}) => {
  const { mutate: submitInvoice, isLoading } = useCustomMutation<SubmitInvoiceResponse>();

  const submit = async (input: { invoiceId?: string; fiscalYear: number }) => {
    try {
      const values = {
        input: {
          invoiceId: input.invoiceId,
          fiscalYear: input.fiscalYear
        }
      };

      submitInvoice({
        meta: {
          gqlMutation: SUBMIT_INVOICE_MUTATION,
        },
        values: values,
        url: "",
        method: "post"
      }, {
        onSuccess: (data) => {
          const response = (data as any)?.data?.submitInvoice || data;

          notification.success({
            message: 'Invoice Submitted Successfully',
            description: 'The invoice has been submitted for approval.',
          });
          onSuccess?.(response);
        },
        onError: (error) => {
          notification.error({
            message: 'Submission Failed',
            description: error.message || 'Failed to submit the invoice.',
          });
          onError?.(error);
        }
      });
    } catch (error) {
      console.error('Error submitting invoice:', error);
      onError?.(error);
    }
  };

  return {
    submit,
    isLoading
  };
};